const TemplateModal = require('./wrdetail-modal.hbs');
const TemplateEinsaetze = require('./wrdetail-einsaetze.hbs');
const Tabs = require('../common/tabs');
const axios = require('../common/axios');

function mapAssignment(assignment) {
	return {
		...assignment,
		team: {
			...assignment.team,
			competitionsAsString: assignment.team.competitions.map(c => ([c.group, c.class, c.kind].join(' '))).join(', ')
		}
	};
}

function WrdetailModal(id, name) {

	function create(id, name) {
		return TemplateModal({id, name});
	}

	function loadPlanung(offset) {
		return axios.get(`/api/zwe/wrdetails/${id}/planung?offset=${offset}`).then(
			response => response.data.map(mapAssignment)
		).then(
			data => TemplateEinsaetze({
				tab: '#tab_planung',
				forward: {
					disabled: data.length === 0,
					label: 'später',
					offset: offset + 5
				},
				backward: {
					disabled: offset == 0,
					label: 'früher',
					offset: offset - 5
				},
				data
			})
		)
	}

	function loadHistorie(offset) {
		return axios.get(`/api/zwe/wrdetails/${id}/historie?offset=${offset}`).then(
			response => response.data.map(mapAssignment)
		).then(
			data => TemplateEinsaetze({
				tab: '#tab_historie',
				forward: {
					disabled: offset == 0,
					label: 'später',
					offset: offset - 5,
				},
				backward: {
					disabled: data.length === 0,
					label: 'früher',
					offset: offset + 5
				},
				data
			})
		);
	}

	let planungOffset = 0;
	let historieOffset = 0;

	let tabs;

	return {
		attach: (selectorOrElement) => {
			const element = typeof selectorOrElement === 'string' ? document.querySelector(selectorOrElement) : selectorOrElement;
			if (element) {
				element.innerHTML = create(id, name);
				tabs = Tabs.create(element, '#tab_planung', [
					{
						type: 'activate', callback: (tab) => {
							if (tab.id === '#tab_planung') {
								loadPlanung(planungOffset).then(
									content => tab.updateContent(content)
								);
							} else if (tab.id === '#tab_historie') {
								loadHistorie(historieOffset).then(
									content => tab.updateContent(content)
								);
							}
						}
					},
				]);
			} else {
				console.warn(`could not find element ${selectorOrElement}`);
			}
		},
		pageAssignments: (tabId, offset) => {
			if (tabs) {
				const tab = tabs.getAllTabs().find(t => t.id === tabId);
				if (tab) {
					if (tabId === '#tab_planung') {
						loadPlanung(offset).then(
							content => tab.updateContent(content)
						);
					} else if (tabId === '#tab_historie') {
						loadHistorie(offset).then(
							content => tab.updateContent(content)
						);
					}
				} else {
					console.warn(`could not find tab ${tabId}`);
				}
			} else {
				console.warn('tabs not defined');
			}
		}
	}
}

module.exports = WrdetailModal;
